export default __webpack_public_path__ + "static/ScientificProvenApproach-d29a06e990c7f271a5f7c5d3978eed00.svg";